// 列表模式-配合-招采方式-展示规则枚举
export const MODE_ENUM = {
  CARD_1: [2, 3, 5],
  CARD_2: [2, 5],
  TABLE_1: [1, 4, 5],
  MAP_1: [1, 3, 5],
  MAP_2: [1, 5],
};
// 招标类型默认类型获取
export const getDefaltType = async (type) => {
  let defaultTypeEnum = {
    14: [
      {
        no: "1",
        name: "商业/办公用地",
      },
      {
        no: "2",
        name: "住宅用地",
      },
      {
        no: "3",
        name: "工业用地",
      },
      {
        no: "4",
        name: "农业用地",
      },
      {
        no: "5",
        name: "综合用地",
      },
      {
        no: "6",
        name: "旅游用地",
      },
      {
        no: "7",
        name: "其他用地",
      },
    ],
  };
  return defaultTypeEnum[type]
};
